module.exports = __webpack_public_path__ + "img/Exit_red.e7c5706f.png";